const INFO_TYPES = {
  OVERVIEW: "Overview",
  PROGRAM: "Program",
  BILLING: "Billing",
};

const DEFAULT_TITLE = "Subscription Reports";

export { DEFAULT_TITLE, INFO_TYPES };
